// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cc48176f","455":"b8d1f94b","977":"6436af7e"}[chunkId] + ".chunk.js";
};